module.exports = __webpack_public_path__ + "static/media/smart-soft.795149b7.webp";